import { Col, message, Row, Spin } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    FormItem,
    InputItem,
    ButtonItem,
    ErrorItem,
    TextAreaItem,
    TransferItem,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";

class AgregarIndustria extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasFamilias: [],
    };
    componentDidMount() {
        this.consultarTodo();
    }
    // Las familias del catálogo se piden con el mismo endpoint que llena la tabla
    // de la pantalla (no con selectFamiliasImplementacionItem, que filtra por
    // empresaId y en PanelPrincipal no hay empresa seleccionada).
    consultarTodo() {
        this.setState({ loading: true });
        axios
            .post(
                "familiasImplementacion/selectTodasFamiliasImplementacion",
                { page: 1, pageSize: 1000, valor: 3, filters: {} },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({
                    loading: false,
                    todasFamilias: res.data.success === 2 ? res.data.data : [],
                });
            })
            .catch(() => this.setState({ loading: false, todasFamilias: [] }));
    }
    cerrarAgregarIndustria(guardado) {
        this.props.cerrarAgregarIndustria(guardado);
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        const editando = !!this.props.industria;
        const cuerpo = {
            nombre: values.nombre,
            descripcion: values.descripcion,
            familiaIds: values.familias || [],
        };
        if (editando) cuerpo.industriaId = this.props.industria._id;

        this.setState({ loading: true });
        axios
            .post(
                editando ? "industrias/editarIndustria" : "industrias/agregarIndustria",
                cuerpo,
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success(
                        editando ? "Industria editada" : "Se ha registrado una industria"
                    );
                    this.cerrarAgregarIndustria(true);
                } else if (res.data.success === 1) {
                    message.error(
                        editando
                            ? "No se puede editar la industria"
                            : "No se puede registrar la industria"
                    );
                } else {
                    message.error("Hubo un error y la industria no se guardo");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Hubo un error y la industria no se guardo");
            });
    }
    render() {
        const industria = this.props.industria;
        const editando = !!industria;

        const familiasTransfer = this.state.todasFamilias.map((familia) => ({
            key: familia._id,
            title: familia.nombre,
            description: familia.tipoDeFamilia || "",
        }));

        return (
            <div className="card-background">
                <Spin spinning={this.state.loading}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                            flexWrap: "wrap",
                            borderBottom: "1px solid #f0f0f0",
                            paddingBottom: 12,
                            marginBottom: 16,
                        }}
                    >
                        <span style={{ fontSize: 16, fontWeight: 700, color: "#3c4b53" }}>
                            {editando ? "Editar Industria" : "Agregar Industria"}
                        </span>
                        {editando ? (
                            <span style={{ fontSize: 12, color: "#7b8a92" }}>
                                {industria.nombre}
                            </span>
                        ) : null}
                    </div>

                    <Form
                        ref={this.formRef}
                        name="agregarIndustria"
                        layoutForm="vertical"
                        initialValues={{
                            nombre: industria ? industria.nombre : undefined,
                            descripcion: industria ? industria.descripcion : undefined,
                            familias: industria
                                ? (industria.familias || []).map((familia) => familia._id)
                                : [],
                        }}
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <GeneralFormLayout
                            cards={[
                                {
                                    title: "INDUSTRIA",
                                    lg: 24,
                                    content: (
                                        <Row gutter={[12, 0]}>
                                            <Col xs={24} md={10}>
                                                <FormItem
                                                    name="nombre"
                                                    label="Nombre"
                                                    required
                                                    margin
                                                    pattern
                                                >
                                                    <InputItem placeholder="Ej. Construcción" />
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} md={14}>
                                                <FormItem
                                                    name="descripcion"
                                                    label="Descripción"
                                                    margin
                                                    pattern
                                                >
                                                    <TextAreaItem
                                                        placeholder="Para qué tipo de empresas aplica esta industria"
                                                        autoSize={{ minRows: 2, maxRows: 4 }}
                                                    />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    ),
                                },
                                {
                                    title: "FAMILIAS",
                                    lg: 24,
                                    headerRight:
                                        "Pasa a la derecha las familias que pertenecen a esta industria",
                                    content: (
                                        <FormItem name="familias" valuePropName="targetKeys" margin>
                                            <TransferItem
                                                dataSource={familiasTransfer}
                                                titles={[
                                                    "Familias disponibles",
                                                    "Familias de esta industria",
                                                ]}
                                                listStyle={{ flex: 1, height: 420 }}
                                                render={(item) =>
                                                    item.description
                                                        ? item.title + " · " + item.description
                                                        : item.title
                                                }
                                                filterOption={(texto, item) =>
                                                    (item.title + " " + item.description)
                                                        .toLowerCase()
                                                        .indexOf(texto.toLowerCase()) >= 0
                                                }
                                                locale={{
                                                    itemUnit: "familia",
                                                    itemsUnit: "familias",
                                                    searchPlaceholder: "Buscar familia",
                                                    notFoundContent: "Sin familias",
                                                }}
                                            />
                                        </FormItem>
                                    ),
                                },
                            ]}
                            actionButtons={
                                <div
                                    style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
                                >
                                    <ButtonItem
                                        type="primary"
                                        rojoB
                                        style={{ display: "inline-block" }}
                                        onClick={() => this.cerrarAgregarIndustria()}
                                    >
                                        Cancelar
                                    </ButtonItem>
                                    <ButtonItem
                                        type="primary"
                                        cyanB
                                        htmlType="submit"
                                        style={{ display: "inline-block" }}
                                    >
                                        {editando ? "Guardar" : "Agregar"}
                                    </ButtonItem>
                                </div>
                            }
                        />
                    </Form>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(AgregarIndustria);
